import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'react-bootstrap';
import _ from 'lodash';
import { connect } from 'react-redux';
import moment from 'moment';
import * as actions from '../../../../redux/actions/reportsTabAction';
import FormOptions from '../../../../components/Modules/FormOptions';
import FormOption from '../../../../components/Modules/FormOption';
import WarningBox from '../../../../components/Modules/WarninigBox';
import ResultsTable from '../../../../components/Modules/ResultsTable';
import LoadingBar from '../../../../components/Modules/LoadingBar';
import InfoMessage from '../../../../components/Modules/InfoMessage';
import AlertMessage from '../../../../components/Modules/AlertMessage';
import LoggedOutInfoMessage from '../../../../components/Elements/LoggedOutInfoMessage';
import SubmitButton from '../../../../components/Buttons/SubmitButton';
import Hints from './Hints/Hints';
import Bankruptcy from './ReportsTabForms/Bankruptcy/Bankruptcy';
import Civil from './ReportsTabForms/Civil/Civil';
import Criminal from './ReportsTabForms/Criminal/Criminal';
import AutomateReportAndDelivery from './ReportsTabForms/AutomateReportAndDelivery/AutomateReportAndDelivery';
import casePropertiesParse from '../../../../utils/casePropertiesParse';
import dateFormat from '../../../../utils/dateFormat';
import Receipt from '../../../../components/Modules/Receipt/Receipt';
import csvIcon from '../../../../images/icon-reports-csv.png';
import alertsIcon from '../../../../images/icon-reports-alerts.png';
import searchIcon from '../../../../images/icon-reports-search.png';
// import Filings from '../../Filings';
import '../../../../containers/BootstrapCustom.less';
import { isCourtDrive } from '../../../../util/globalUtils';
import './ReportsTab.less';


const courtDriveSearchForms = {
  bankruptcy: {
    title: 'Bankruptcy',
    component: Bankruptcy,
  },
  civil: {
    title: 'Civil',
    component: Civil,
  },
  criminal: {
    title: 'Criminal',
    component: Criminal,
  },
};

const inforuptcySearchForms = {
  bankruptcy: {
    title: 'Bankruptcy',
    component: Bankruptcy,
  },
};

const searchForms = isCourtDrive() ? courtDriveSearchForms : inforuptcySearchForms;


class ReportsTab extends Component {
  constructor(props) {
    super(props);

    const formType = 'bankruptcy';

    this.initialState = {
      formType,
      isOpenAutomateCollapse: false,
      ...this.initiateForm[formType]({}),
      ...this.initiateForm.automateMailing(),
      searchType: this.formTypeDataToSubmit[formType],
      mainFormError: null,
      isFormAreaPostFaded: false,
    };

    this.state = this.initialState;
  }

  componentWillReceiveProps(props) {
    const { reportsTabReducer: reducerOld } = this.props;
    const isReportsDataReadyOld = reducerOld.get('isReportsDataReady');

    const { reportsTabReducer: reducer } = props;
    const isReportsDataReady = reducer.get('isReportsDataReady');
    const isReportsDataErrorOccurred = reducer.get('isReportsDataErrorOccurred');
    const isAutoMateMailingReadyErrorOccurred = reducer.get('isAutoMateMailingReadyErrorOccurred');
    const errorMessage = reducer.get('errorMessage');

    if (isReportsDataReady && !isReportsDataReadyOld) {
      this.setState({ isFormAreaPostFaded: true });
    }

    this.setState({
      mainFormError: isReportsDataErrorOccurred ? 'Server error.' : null,
      automateMailingError: isAutoMateMailingReadyErrorOccurred ? `${errorMessage}.` : null,
    });
  }

  onFormAreaClick = () => {
    this.setState({ isFormAreaPostFaded: false });
  };

  setFormValue = (name, value) => {
    this.setState({ [name]: value });
  };

  errorClearMainForm = () => {
    this.setState({ mainFormError: null });
  };

  errorClearAutomateMailing = () => {
    this.setState({ automateMailingError: null });
  };

  errorReportAutomateMailing = (fieldId) => {
    this.setState({ automateMailingError: this.errorReportMessageExtract(fieldId) });
  };

  errorReportMainForm = (fieldId) => {
    this.setState({ mainFormError: this.errorReportMessageExtract(fieldId) });
  };

  errorReportMessageExtract = fieldId => `${this.requiredFields[fieldId]} is required! Please fill the field.`;

  formTypeSelect = (formType) => {
    this.setState({
      formType,
      searchType: this.formTypeDataToSubmit[formType],
    });

    this.setState(this.initiateForm[formType](this.state));
  };

  select = (name, value) => {
    this.setFormValue(name, value);

    if (name === 'dateFrom') {
      this.setFormValue('dateTo', value);
    }
  };

  multiselect = (name, value) => {
    const nextValue = (!_.isEmpty(value))
      ? value.split(',')
      : value;

    this.setFormValue(name, nextValue);
  };

  formDataParse = () => {
    const {
      searchType,
      caseProperties,
    } = this.state;

    const allowedParams = this.filterAllowedParams(this.state);

    return Object.assign({}, allowedParams, {
      search_type: {
        court_type: searchType,
      },
    }, casePropertiesParse(caseProperties));
  };

  trigAutomateCollapse = () => {
    this.setState({
      isOpenAutomateCollapse: !this.state.isOpenAutomateCollapse,
    });
  };

  formTypeDataToSubmit = {
    bankruptcy: 'localcourtreport',
    civil: 'localcourtreport_cv',
    criminal: 'localcourtreport_cr',
  };

  requiredFields = {
    region: 'Region',
    startTime: 'Start time',
    endTime: 'Start time',
    frequency: 'Frequency',
  };

  filterAllowedParams = (params) => {
    const { formType } = this.state;

    const paramNameMapper = {
      region: 'region',
      chapter: 'chapter',
      caseType: 'case_type',
      caseFlag: 'case_flags',
      dateType: 'date_type',
      dateFrom: 'date_from',
      dateTo: 'date_to',
      includeCVBCases: 'cvbcases',
      citation: 'citation',
      natureOfSuit: 'nature_of_suit',
      jurisdiction: 'jurisdic',
      typeOfDebtor: 'type_of_debtor',
      natureOfDebt: 'nature_of_debt',
      natureOfBusiness: 'nature_of_business',
      assets: 'asset_notice',
      partyInfo: 'party_info',
    };

    const allowedFields = Object.keys(this.initiateForm[formType]({}));

    const filtered = _.pick(params, allowedFields);
    const filteredParams = _.reduce(filtered, (result, value, key) => {
      const paramKey = paramNameMapper[key];
      let next = {};

      if (paramKey !== undefined) {
        const v = (key === 'dateFrom' || key === 'dateTo')
          ? dateFormat(value)
          : value;

        next = { [paramKey]: v };
      }

      return Object.assign({}, result, next);
    }, {});

    return filteredParams;
  }

  initiateForm = {
    bankruptcy: (o) => {
      const now = new Date();

      return {
        region: o.region || '',
        chapter: o.chapter || ['11'],
        caseType: o.caseType || 'bk',
        dateType: o.dateType || 'filed',
        dateFrom: o.dateFrom || now,
        dateTo: o.dateTo || now,
        typeOfDebtor: o.typeOfDebtor || '',
        natureOfDebt: o.natureOfDebt || '',
        natureOfBusiness: o.natureOfBusiness || '',
        assets: o.assets || '',
        caseProperties: o.caseProperties || 'open_cases',
        partyInfo: o.partyInfo || '',
        citation: o.citation || '',
        caseFlag: o.caseFlag || '',
        includeCVBCases: o.includeCVBCases || '',
        natureOfSuit: o.natureOfSuit || '',
        jurisdiction: o.jurisdiction || '',
      };
    },
    civil: (o) => {
      const now = new Date();
      return {
        region: o.region || 'almbke',
        caseType: '',
        natureOfSuit: o.natureOfSuit || '',
        dateFrom: o.dateFrom || now,
        dateTo: o.dateTo || now,
        cause: o.cause || '',
        jurisdiction: o.jurisdiction || '',
        caseFlag: o.caseFlag || '',
        caseProperties: o.caseProperties || 'open_cases',
        citation: o.citation || '',
        includeCVBCases: o.includeCVBCases || '',
      };
    },
    criminal: () => {
      const now = new Date();

      return {
        region: '',
        caseType: '',
        citation: '',
        dateFrom: now,
        dateTo: now,
        caseFlag: '',
        countStatus: '',
        includeCVBCases: '',
        caseProperties: 'pending_defendants',
        typeOfDebtor: '',
        natureOfDebt: '',
        natureOfBusiness: '',
        assets: '',
        partyInfo: '',
        natureOfSuit: '',
        jurisdiction: '',
      };
    },
    automateMailing: () => ({
      frequency: '10080',
      startTime: null,
      endTime: null,
    }),
  };

  submit = () => {
    if (!client_code_is_valid()) {
      this.setState({ mainFormError: 'Please set a valid client code first.'})
      return;
    }

    if (!this.state.region) {
      return this.errorReportMainForm('region');
    }

    this.errorClearMainForm();

    this.props.dispatch(actions.reports(this.formDataParse()));
  };

  automateMailing = () => {
    const {
      region,
      frequency,
      startTime,
      endTime,
    } = this.state;

    if (!region) return this.errorReportAutomateMailing('region');
    if (!frequency) return this.errorReportAutomateMailing('frequency');
    if (!startTime) return this.errorReportAutomateMailing('startTime');
    if (!endTime) return this.errorReportAutomateMailing('endTime');

    this.errorClearAutomateMailing();

    const end = (moment.isMoment(endTime))
      ? endTime.unix() * 1000
      : endTime.getTime();

    const start = (moment.isMoment(startTime))
      ? startTime.unix() * 1000
      : startTime.getTime();

    const params = _.pickBy({
      ...this.formDataParse(),

      frequency,
      end_time: end,
      start_time: start,
    }, _.identity);

    this.setState({
      startTime: null,
      endTime: null,
    });

    this.props.dispatch(actions.automateMailing(params));
  };

  refineSearch = () => {
    window.scrollTo(0, 0);
    this.setState({ isFormAreaPostFaded: false });
  };

  render() {
    if (window.Drupal.settings.currentUser === 0) return <LoggedOutInfoMessage />;

    const {
      formType,
      mainFormError,
      automateMailingError,
      isFormAreaPostFaded,
    } = this.state;

    const reducer = this.props.reportsTabReducer;

    const isAutoMailingLoading = reducer.getIn(['automateMailing', 'isLoading'], false);
    const isReportsDataReady = reducer.get('isReportsDataReady');
    const isReportsDataErrorOccurred = reducer.get('isReportsDataErrorOccurred');
    const isAutoMateMailingReady = reducer.get('isAutoMateMailingReady');
    const reports = reducer.get('reports');
    let receipts = reducer.getIn(['receipts', 0, 0, 'text']);
    receipts = receipts ? receipts.toObject() : {};

    const Form = searchForms[formType].component;

    const FormOptionList = Object.keys(searchForms).map(eventKey => (
      <FormOption key={eventKey} eventKey={eventKey}>{searchForms[eventKey].title}</FormOption>
    ));

    const hasRecords = isReportsDataReady && reports.size > 0;

    const csvClassName = (hasRecords)
      ? ''
      : 'inactive';

    const reportsTabFormsCls = !isReportsDataErrorOccurred && (isReportsDataReady === false || isFormAreaPostFaded)
      ? 'reports-tab-forms reports-tab-forms-faded'
      : 'reports-tab-forms';

    const csvLink = this.props.reportsTabReducer.get('csvDownloadLink');
    const csvUrl = this.props.reportsTabReducer.get('csvDownloadUrl');

    return (
      <div className="reports-tab">

        <div className="filings-form">
          <FormOptions onSelect={this.formTypeSelect} activeKey={formType}>{FormOptionList}</FormOptions>

          <div className="reports-search-form-container">
            <div onClick={this.onFormAreaClick} className={reportsTabFormsCls}>
              <Form
                setFormValue={this.setFormValue}
                select={this.select}
                multiselect={this.multiselect}

                {...this.state}
              />
              <SubmitButton disabled={isReportsDataReady === false} onClick={this.submit}>Run
                Report
              </SubmitButton>
              {isReportsDataReady === false && <LoadingBar />}
              {mainFormError && <AlertMessage>{mainFormError}</AlertMessage>}
            </div>
            <Hints />
          </div>
          {isReportsDataReady && !isReportsDataErrorOccurred && (
            <div className="reports-tab-footer">
              { hasRecords ? (
                <WarningBox>
                  You have results below. Click a case number to select a case,
                  or select an action from the choices below:
                </WarningBox>
              ) : (
                <WarningBox>
                  No result were found from PACER. Please revise your criteria to broaden the search parameters.
                </WarningBox>
              )}
              {isReportsDataReady && (
                <div className="local-search-actions">
                  <form action={csvLink} method="post">
                    <input type="hidden" name="url" value={csvUrl} />
                    <button className={csvClassName} type="submit">
                      <img src={csvIcon} alt="" />
                      <span>Download CSV</span>
                    </button>
                  </form>
                  <div onClick={this.trigAutomateCollapse}>
                    <img src={alertsIcon} alt="" />
                    <span>Automate Report and Delivery</span>
                  </div>
                  <div onClick={this.refineSearch}>
                    <img src={searchIcon} alt="" />
                    <span>Refine Your Search</span>
                  </div>
                </div>
              )}
              {isReportsDataReady && (
                <div>
                  <Collapse in={this.state.isOpenAutomateCollapse}>
                    <div>
                      <AutomateReportAndDelivery
                        {...this.state}
                        setFormValue={this.setFormValue}
                        automateMailing={this.automateMailing}
                      />
                      {automateMailingError ? (
                        <AlertMessage>{automateMailingError}</AlertMessage>
                      ) : isAutoMateMailingReady ? (
                        <InfoMessage>
                          Your alert has been successfully configured. Click
                          <a href="/search-alerts#realtime-alerts-top" target="_blank"> here </a>
                          to see all your alerts.
                        </InfoMessage>
                      ) : isAutoMailingLoading ? <LoadingBar /> : null}
                    </div>
                  </Collapse>
                  <ResultsTable
                    titles={['Case Title', 'Court', 'Case No', 'Chapter', 'Date Filed', 'Date Closed', 'Disposition']}
                  >{reports}
                  </ResultsTable>
                  <Receipt>{receipts}</Receipt>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

ReportsTab.propTypes = {
  reportsTabReducer: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    reportsTabReducer: state.get('reportsTabReducer'),
  };
}


export default connect(mapStateToProps)(ReportsTab);



/** WEBPACK FOOTER **
 ** ./src/pages/filings/SearchCourtRecords/ReportsTab/ReportsTab.js
 **/